import React from 'react';
import { Modal, Box, Button, Typography } from '@mui/material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const ModalAccept = ({ open, onClose, onConfirm, message }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6">{message}</Typography>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-around' }}>
          <Button onClick={onConfirm} color="primary" variant="contained">
            Подтвердить
          </Button>
          <Button onClick={onClose} color="secondary" variant="outlined">
            Отмена
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalAccept;
